export const { TEXT_NODE, COMMENT_NODE, ELEMENT_NODE, DOCUMENT_FRAGMENT_NODE } = Node

export type VComment = { nodeType: typeof COMMENT_NODE, nodeValue: string | null }
export type VText = { nodeType: typeof TEXT_NODE, nodeValue: string | null }
export type VElement = {
  nodeType: typeof ELEMENT_NODE,
  tagName: string,
  attributes: Record<string, string>,
  properties: Record<string, unknown>,
  eventListeners?: EventListener,
  childNodes: VNode[],
  inits: ((el: Element) => void)[]
}

export type VNode = VText | VComment | VElement

export const withFunc = (body: string, ...args: string[]) =>
  new Function(...args, `with(this)return(${body})`)

export const ieval = (expr: string, data: unknown) =>
  withFunc(expr).call(data)

export const flatMap = <X, Y>(xs: Iterable<X>, f: (x: X, i: number) => Iterable<Y>) => {
  let rv = [], i = 0
  for (let x of xs) for (let o of f(x, i++)) rv.push(o)
  return rv
}
